import React from 'react'
import { Button } from 'antd'
import { IconHelper } from '../../helpers'
import { translate } from 'react-i18next'

const Header = ({ roomName, t }) => {
    const { IconBack } = IconHelper
    return (
        <>
            <div className="lobby-header container">
                <div className="lobby-header-left">
                    <IconBack onClick={() => window.history.back()} style={{ cursor: 'pointer' }} />
                    <span>{roomName}</span>
                </div>
                <div>
                    <Button onClick={() => window.location.href = `${window._env_.vRoomUrl}/${roomName}`} className="btn-danger">{t("lobby_button_join_room")}</Button>
                </div>
            </div>
        </>
    )
}

export default translate()(Header)